<script setup>
import { defineComponent } from "vue";
import PageTitle from "@/components/common/PageTitle.vue";
import ChangePassword from "@/components/myProfile/ChangePassword.vue";
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const breadcrumbs = [
    { label: t('components.myProfile.changePassword.pageTitle') },
];
</script>
<template>
    <PageTitle :breadcrumbs="breadcrumbs" />
    <ChangePassword />
</template>

